// Textos de la preview de la llamada de configuración. Son los cuerpos LITERALES de las
// plantillas config_confirmada_crm / recordatorio_config_crm (aws_lambdas/_shared_demo/
// demoTemplates.js) con los params sustituidos — si tocas la plantilla, toca esto y su test.
// `duracion` («1 hora», «1 h 30 min»…, 20/10/2026): con ella, el texto de las plantillas *_dur_crm (la duración en su
// sitio y «Hasta pronto.» sin «¡»); sin ella, el de siempre.
export function buildConfigConfirmationText({ nombre, dateEs, timeStr, asesor, telefono, duracion }) {
  if (duracion) {
    return (
      "Llamada de configuración agendada ✅\n\n" +
      `${nombre}, tu videollamada de configuración de ConextCRM queda agendada para el *${dateEs}* a las *${timeStr}* (${duracion}).\n\n` +
      `Te atenderá tu asesor ${asesor}: pondremos en marcha tu negocio y te pasaremos los accesos.\n\n` +
      `Si necesitas cambiar la hora, escríbele por WhatsApp al ${telefono}. Hasta pronto.`
    );
  }
  return (
    "Llamada de configuración agendada ✅\n\n" +
    `${nombre}, tu videollamada de configuración de ConextCRM queda agendada para el *${dateEs}* a las *${timeStr}* (unos 30 min).\n\n` +
    `Te atenderá tu asesor ${asesor}: pondremos en marcha tu negocio y te pasaremos los accesos.\n\n` +
    `Si necesitas cambiar la hora, escríbele por WhatsApp al ${telefono}. ¡Hasta pronto!`
  );
}

export function buildConfigReminderText({ nombre, dateEs, timeStr, asesor, telefono, duracion }) {
  if (duracion) {
    return (
      `Hola ${nombre}, te recordamos tu videollamada de configuración de ConextCRM del *${dateEs}* a las *${timeStr}* (${duracion}).\n\n` +
      `Te atenderá tu asesor ${asesor}: pondremos en marcha tu negocio y te pasaremos los accesos.\n\n` +
      `Si necesitas cambiar la hora, escríbele directamente por WhatsApp al ${telefono}.\n\n` +
      "Nos confirmas que te viene bien?"
    );
  }
  return (
    `Hola ${nombre}, te recordamos tu videollamada de configuración de ConextCRM del *${dateEs}* a las *${timeStr}* (unos 30 minutos).\n\n` +
    `Te atenderá tu asesor ${asesor}: pondremos en marcha tu negocio y te pasaremos los accesos.\n\n` +
    `Si necesitas cambiar la hora, escríbele directamente por WhatsApp al ${telefono}.\n\n` +
    "¿Nos confirmas que te viene bien?"
  );
}

// Recordatorio de la DEMO (recordatorio_demo_crm). Cuerpo copiado LITERAL de la API de Meta
// (GET /message_templates?name=recordatorio_demo_crm, 2026-07-29, id 1326009819613776,
// APPROVED/UTILITY). Header TEXT: "RECORDATORIO DE PRESENTACIÓN"; botón "Confirmar cita".
export function buildDemoReminderText({ nombre, dateEs, timeStr, asesor, telefono }) {
  return (
    `Hola ${nombre}, te recordamos tu presentación de ConextCRM del *${dateEs}* a las *${timeStr}*.\n\n` +
    `Es una videollamada de unos 30 minutos y te atenderá ${asesor}.\n\n` +
    `Si necesitas cambiar la hora o tienes cualquier duda, escríbele directamente por WhatsApp al ${telefono}.\n\n` +
    "¿Nos confirmas que te viene bien?"
  );
}

/** Duración hablada (la misma que p_createAppointment/demoReminder.js textoDuracion). PURA. */
export function textoDuracion(min) {
  const m = Math.round(Number(min));
  if (!Number.isFinite(m) || m <= 0) return "unos 30 min";
  if (m < 60) return `unos ${m} min`;
  const h = Math.floor(m / 60); const resto = m % 60;
  if (!resto) return h === 1 ? "1 hora" : `${h} horas`;
  return `${h} h ${resto} min`;
}
